import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PropTypes from "prop-types";
import { useTranslation, withTranslation } from "react-i18next";

// Facture Redux States
import { GET_FACTURES } from "./actionType";

import { factureApiResponseSuccess, factureApiResponseError } from "./action";

//Include Both Helper File with needed methods
import {
  getFactures as getFacturesApi,
} from "../../helpers/fakebackend_helper";

function* getFactures() {
  try {
    const response = yield call(getFacturesApi);
    yield put(factureApiResponseSuccess(GET_FACTURES, response));
  } catch (error) {
    yield put(factureApiResponseError(GET_FACTURES, error));
  }
}

export function* watchGetFactures() {
  yield takeEvery(GET_FACTURES, getFactures);
}

function* factureSaga() {
  yield all([fork(watchGetFactures)]);
}

export default factureSaga;
